<div class="pb-30 pt-20 school-invites">
  <div class="container">
    <div class="row">
      <app-article [pageName]="'SCHOOL_INVITES'" (pageTeacherDataLoaded)="handlePageData($event)"></app-article>
      <div class="col-lg-8 col-md-12">
        <h4 class="mb-20">School Invites</h4>
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-link" [ngClass]="{ active: activeTab === 'invites' }" (click)="onTabChange('invites')"
              id="nav-invite-tab" data-bs-toggle="tab" data-bs-target="#nav-invite" type="button" role="tab"
              aria-controls="nav-invite" aria-selected="true">
              Invites
            </button>
            <button class="nav-link" [ngClass]="{ active: activeTab === 'history' }" (click)="onTabChange('history')"
              id="nav-history-tab" data-bs-toggle="tab" data-bs-target="#nav-history" type="button" role="tab"
              aria-controls="nav-history" aria-selected="false">
              History
            </button>
          </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show" [ngClass]="{ active: activeTab === 'invites' }" id="nav-invite"
            role="tabpanel" aria-labelledby="nav-invite-tab">
            <form [formGroup]="schoolInvitesFilterForm">
              <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-10 mt-20 form-floating">
                  <label for="search_by_name" id="search_by_name_label">Search by school name</label>
                  <div class="d-flex name-input">
                    <input id="search_by_name" aria-label="Search by school name" aria-labelledby="search_by_name_label"
                      formControlName="filter_name" type="text" class="form-control" />
                    <button class="input-group-text" role="button" (click)="getFilterInputs()">
                      <i class="bi bi-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            @if (invitesData.length != 0) {
            <div>
              @if (invitesSchoolsList | async; as pendinglist) {
              <div class="row mt-20 sub-header align-items-center">
                <div class="col-lg-4 col-md-4">
                  <input appFocus appClick #checkAll [(ngModel)]="selectAllCheck" class="form-check-input mt-0 mr-5"
                    id="checkAll" type="checkbox" (change)="selectAll('All', $event)" />
                  <span class="text-r-m-16">{{ schoolDetails.length }} matches found</span>
                </div>
                <div class="col-lg-8 col-md-8 text-regular-medium pl-10"
                  [ngClass]="hideButton ? 'input-cursor-na' : ''">
                  <div class="d-flex align-items-center justify-content-end">
                    <a role="button" appClick [appFocus]="hideButton ? '-1' : '0'" aria-label="Decline Selected"
                      class="h_b c-p d-flex align-items-center clr-cc-vilot text-regular-bold"
                      (click)="accepetRequestModal('decline')">
                      <i class="bi bi-x-lg fs-13 me-1"></i> Decline selected
                    </a>
                    <a role="button" appClick [appFocus]="hideButton ? '-1' : '0'" aria-label="Accept Selected"
                      class="h_b c-p d-flex align-items-center ml-10 clr-cc-vilot text-regular-bold"
                      (click)="accepetRequestModal('accept')">
                      <i class="bi bi-check-lg fs-19 me-1"></i> Accept selected
                    </a>
                  </div>
                </div>
              </div>

              <form [formGroup]="declineInviteForm">
                <div>
                  @for (item of invitesData; track item; let i = $index) {
                  <div class="card mt-10 px-15">
                    <div class="row align-items-center">
                      <div class="col-lg-8 col-md-8 col-11">
                        <div class="d-flex">
                          <div class="pic-and-check">
                            <input appClick class="form-check-input mr-10 c-p" type="checkbox"
                              (change)="selectAll(item, $event)" [checked]="item.isChecked" [attr.id]="item.school.id"
                              [attr.aria-label]="item.school.rta_user.full_name" />
                          </div>
                          <div class="pic-and-check ml-0">
                            <img alt="img" [src]="
                                item.school.profile_image
                                  ? item.school.profile_image
                                  : '../../../../assets/images/teacher-static-profile.png'
                              " class="profile-picture img-complete-match" />
                          </div>
                          <div class="pic-and-check ml-10">
                            <h6 class="text-regular-bold fs-16 mb-1">
                              {{ item.school.title }}
                              <span class="text-success">●</span>
                            </h6>
                            <div class="clr-grey-3 fs-12">
                              <p class="pt-4 pb-4">
                                <span>{{
                                  item.school.address.address_timezone.state
                                  }},
                                  {{
                                  item.school.address.address_timezone.country
                                  }}</span>
                                | <span>{{ item.distance }} km</span>
                              </p>
                              <p>
                                <span>{{
                                  item.school.rta_user.full_name
                                  }}</span>
                                | <span>{{ item.school.phone_number }}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4" [ngClass]="hideButton ? '' : 'input-cursor-na'">
                        <div class="accept-decline">
                          <button type="button" appClick [appFocus]="hideButton ? '0' : '-1'"
                            class="text-regular-bold btn-outline clr-cc-vilot c-p me-2"
                            (click)="actionModal(item, 'decline')">
                            Decline
                          </button>
                          <button type="button" appClick [appFocus]="hideButton ? '0' : '-1'" class="btn cc_p_btn fs-14"
                            (click)="actionModal(item, 'accept')">
                            Accept
                          </button>
                        </div>
                        <div class="days-ago mt-8">
                          <p class="text-s-m-g-3">
                            Invited on {{ item.last_invite_date }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </form>
              }
            </div>
            } @if (invitesData.length == 0) {
            <div class="card px-30 mt-20">
              <div class="text-center mt-20">
                <p>
                  <img style="width: 180px;" src="assets/PendingInvites_NoHistoryFound.png" alt="No invites found!" />
                </p>
                <p class="title mt-20">You don't have any invites from schools.</p>
              </div>
            </div>
            }
          </div>

          <!-- History Tab -->
          <div class="tab-pane fade" id="nav-history" [ngClass]="{ active: activeTab === 'history' }" role="tabpanel"
            aria-labelledby="nav-history-tab">
            <div class="mt-20">
              <form [formGroup]="schoolInvitesHistoryFilterForm">
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-10 mt-10 form-floating">
                    <label for="search_by_name_history" id="search_by_name_history_label">Search by school name</label>
                    <div class="d-flex name-input">
                      <input id="search_by_name_history" aria-label="Search by name"
                        aria-labelledby="search_by_name_history_label" formControlName="filter_name" type="text"
                        class="form-control" />
                      <button class="input-group-text" role="button" (click)="getFilterInputs()">
                        <i class="bi bi-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>

              @if (historyData.length != 0) { @if (invitesHistorySchoolsList |
              async; as pendingHistory) {

              <div class="mt-20">
                @for (item of historyData; track item; let i = $index) {
                <div class="card mt-10 px-15">
                  <div class="row align-items-center">
                    <div class="col-lg-8 col-md-8 col-11">
                      <div class="d-flex align-items-center">
                        <div class="pic-and-check ml-0">
                          <img alt="img" [src]="
                              item.school.profile_image ||
                              '../../../../assets/images/teacher-static-profile.png'
                            " class="profile-picture img-complete-match" />
                        </div>
                        <div class="pic-and-check ml-10">
                          <h6 class="text-regular-bold fs-16 mb-1">
                            {{ item.school.title }}
                            <span class="text-success">●</span>
                          </h6>
                          <div class="clr-grey-3 fs-12">
                            <p class="pt-4 pb-4">
                              <span>{{
                                item.school.address.address_timezone.state
                                }},
                                {{
                                item.school.address.address_timezone.country
                                }}</span>
                              | <span>{{ item.distance }} km</span>
                            </p>
                            <p>
                              <span>{{ item.school.rta_user.full_name }}</span>
                              | <span>{{ item.school.phone_number }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4">
                      @if (item.status == 'PC') {
                      <div class="accept-decline">
                        <p class="clr-green text-regular-bold">Accepted</p>
                      </div>
                      } @else {
                      <div class="accept-decline">
                        <p class="btn-cc-red text-regular-bold">Declined</p>
                      </div>
                      }
                      <div class="days-ago mt-3">
                        <p class="text-s-m-g-3">{{ item.updated_at }}</p>
                      </div>
                      @if (item.decline_reason) {
                      <div class="reason-for-decline mt-3">
                        <button class="notesTooltip c-p h_b">
                          <div class="d-flex align-items-center">
                            <i class="bi bi-exclamation-circle fs-13 mr-4"></i>
                            <p class="text-regular-bold-grey">
                              Reason for decline
                            </p>
                          </div>
                          <div class="notesTooltiptext text-s-m-g-1">
                            {{ item.decline_reason }}
                          </div>
                        </button>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
              } } @if (historyData.length == 0) {
              <div class="card px-30 mt-20">
                <div class="text-center mt-20">
                  <p>
                    <img style="width: 150px;" src="assets/image 31.png"
                      alt="Accept/Decline invites from All invites tab to see them here." />
                  </p>
                  <p class="title mt-20">All your invites can be found here. At the moment, you haven't received any.
                  </p>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Right Sidebar -->
      <div class="col-lg-4 col-md-12">
        <div class="card px-15">
          <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <h5 class="user-title fs-18">School Invites</h5>
              <div class="d-flex align-items-center">
                <div>
                  <h2 class="mb-0 text-regular-medium fs-32 clr-cc-vilot">
                    {{ invitesData.length || 0 }}
                  </h2>
                </div>
                <div>
                  <p class="txt-regular ml-10">
                    <!-- School are adding you to your list. Respond now to start
                    accepting work. -->
                    New schools have added you to their list. Respond now and start booking work.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card px-15 mt-20">
          <h5 id="findNewSchoolsTitle" class="text-regular-medium fs-16 mb-0 mt-3">
            Find new schools on ClassCover
          </h5>
          <p id="findNewSchoolsDesc" class="txt-regular mt-5 mb-5">
            Search schools in your area and request to be added to their list.
          </p>
          <a appFocus class="clr-cc-vilot fs-16 text-regular-bold" (click)="findNewSchool()"
            aria-labelledby="findNewSchoolsTitle" aria-describedby="findNewSchoolsDesc" role="button">
            Find new schools
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
              viewBox="0 0 16 17">
              <path fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
  <ng-template #actionModals>
    <div class="modal-header">
      @if (actionType == 'accept') {
      <h4 class="modal-title" id="exampleModalLabel">
        Accept {{ schoolName }}
      </h4>
      } @if (actionType == 'decline') {
      <h4 class="modal-title" id="exampleModalLabel">
        Are you sure you want to decline {{ schoolName }}?
      </h4>
      }

      <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          @if (actionType == 'accept') {
          <p class="text-regular-medium">
            Are you sure you want to accept {{ schoolName }}?
          </p>
          } @if (actionType == 'decline') {
          <div class="row">
            <form [formGroup]="actionForm">
              <div class="col-md-12">
                <label for="exampleFormControlTextarea1" class="form-label text-regular-medium">Add reason for
                  decline</label>
                <textarea class="form-control mt-5" formControlName="decline_reason" (keyup)="checkLength()"
                  maxlength="500" placeholder="Add Message here..." id="exampleFormControlTextarea1"
                  rows="6"></textarea>
                <p class="txt-regular mt-10 mb-0">
                  Max ({{ this.ShowLenght }} characters)
                </p>
              </div>
            </form>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <button type="button" (click)="actions(school, actionType)" class="cc-blue-btn fs_13">
        Confirm
      </button>
    </div>
  </ng-template>

  <ng-template #acceptRequestModal>
    <div class="modal-header">
      @if (actionType == 'accept') {
      <h4 class="modal-title" id="exampleModalLabel">Accept requests</h4>
      } @if (actionType == 'decline') {
      <h4 class="modal-title" id="exampleModalLabel">
        Are you sure you want to decline selected requests?
      </h4>
      }
      <button type="button" (click)="bsModalRef.hide()" class="btn-close" aria-label="Close"></button>
    </div>

    <div class="modal-body pb-0">
      <div class="row align-items-center">
        <div class="col-md-12">
          @if (actionType == 'accept') {
          <p class="text-regular-medium">
            Are you sure you want to accept selected requests?
          </p>
          } @if (actionType == 'decline') {
          <div class="row">
            <form [formGroup]="actionForm">
              <div class="col-md-12">
                <label for="exampleFormControlTextarea1" class="form-label text-regular-medium">Add reason for
                  decline</label>
                <textarea class="form-control mt-5" formControlName="decline_reason" (keyup)="checkLength()"
                  maxlength="500" placeholder="Add Message here..." id="exampleFormControlTextarea1"
                  rows="6"></textarea>
                <p class="txt-regular mt-10 mb-0">
                  Max ({{ this.ShowLenght }} characters)
                </p>
              </div>
            </form>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="modal-footer mt-10">
      <button type="button" (click)="actions(school, actionType)" class="cc-blue-btn fs_13">
        Confirm
      </button>
    </div>
  </ng-template>
</div>